export const colors = {
  primaryBlue: "#4A83FD",
  lightBlue: "rgba(224, 246, 250, 1)",
  primaryPurple: "rgba(85, 48, 193, 1)",
  lightPurple: "rgba(243, 231, 255, 1)",
  secondaryOrange: "rgba(246, 169, 3, 1)",
  inputFieldGrey: "rgba(247, 246, 248, 1)",
  delete: "rgba(246, 36, 36, 0.17)",
  dropdownGrey: "rgba(233, 236, 241, 1)",
  black: "rgb(0,0,0)",
  white: "rgba(256,256,256,256)",
  grey: "#D9DDE3",
  red: "#FF3750",
};
